export const TICKET_TYPES = {
  CANCEL_FOR_ANY_REASON_TICKET: 'CANCEL_FOR_ANY_REASON_TICKET',
  FLEXIBLE_TICKET: 'FLEXIBLE_TICKET',
  STANDARD_TICKET: 'STANDARD_TICKET',
} as const;

export const ticketErrorId = 'ticket-error-id';

export const TICKET_TITLE_MIN_THRESHOLD_LENGTH = 22;
export const PRICE_MIN_THRESHOLD_LENGTH = 12;

export const POPULAR_PILL_SHOW_TYPE = {
  INSIDE: 'inside',
  NONE: 'none',
  TOP: 'top',
} as const;
